import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// import files
import en from "./locales/en/common.json";
import ar from "./locales/ar/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,

    supportedLngs: ["en", "ar"], // ✅ مهم
    load: "languageOnly",        // ✅ مهم جدا

    resources: {
      en: {
        common: en,
      },
      ar: {
        common: ar,
      },
    },

    ns: ["common"],
    defaultNS: "common",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;